import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import moment from 'moment'
import { useQuery } from '@apollo/client'
import { useCustomer } from 'lib/core/hooks'
import { Spinner } from 'lib/ui/components'
import { residentsListData } from 'app/livbrite/services/community'
import { PublicLayout } from 'app/livbrite/components/PublicLayout'
import { Title, Container } from '../../styled'
import { TitleWrapper, DropDown, DateField, Row, InputContainer } from './styled'
import { useReports } from 'hooks/reports'

export const Dashboard = () => {
  const history = useHistory()
  const [communityIndex, setCommunityIndex] = useState(0)
  const { customer } = useCustomer()
  const { reportsList, reportsLoading } = useReports()
  // @ts-expect-error
  const communities = Object.assign([], customer?.communities)

  if (communities.length > 1) {
    communities.unshift({
      code: 'cc0',
      communityId: 0,
      name: 'Your Portfolio'
    })
  }

  const communityId = communities?.[communityIndex].communityId ?? 0
  const { loading: residentsLoading, data } = useQuery(residentsListData, {
    variables: {
      communityId
    }
  })

  /*
  TEMPORAL DISABLE
  const { loading: reportsLoading, data: dataTypes } = useQuery(reportTypesData, {
    fetchPolicy: 'no-cache'
  })

  const reportTypes = dataTypes?.getReportTypes?.types */
  const residentsData = data?.getResidentList?.residents
  const [residentList, setResidentList] = useState(residentsData)
  const customerName = `${customer?.firstName} ${customer?.lastName}`

  useEffect(() => {
    setResidentList(residentsData)
  }, [
    residentsData
  ])

  return (
    <PublicLayout className='general-content'>
      <Container>
        <TitleWrapper>
          <Title>
            Welcome, <span>{customerName}</span>
          </Title>
          {communities.length > 1 && (
            <DropDown onChange={(e) => setCommunityIndex(parseInt(e.target.value, 10))} value={communityIndex}>
              {communities.map((community: any, index: number) => (
                <option value={index} key={index}>{community.name}</option>
              ))}
            </DropDown>
          )}
        </TitleWrapper>

        <div className='community__residents'>
          <h3>Community Residents</h3>
          {residentsLoading ? (
            <Spinner />
          ) : (
            <>
              <div className='community__residents--heading'>
                <div>
                  Name
                </div>
                <div>
                  Wellness Survey Date
                </div>
                <div>
                  Wellness Survey
                </div>
              </div>
              {residentList ? (
                <ul>
                  {residentList?.map((resident: any) => {
                    return (
                      <Row key={resident.email}>
                        <span>Default User</span>
                        <DateField>{resident.survey_date ? moment(resident.survey_date).format('MMM, DD YYYY') : '-'}</DateField>
                        <InputContainer>
                          <label className='input-wrapper'>
                            <input type='checkbox' defaultChecked={resident.survey_date} disabled />
                            <span className='checkmark' />
                          </label>
                        </InputContainer>
                      </Row>
                    )
                  })}
                </ul>
              ) : (
                <strong className='no-data'>There are no residents available</strong>
              )}
            </>
          )}
        </div>

        <div className='community__report'>
          {reportsLoading ? (
            <Spinner />
          ) : (
            <>
              {reportsList?.map((report, i) => {
                const reportNumber = i+1
                return (
                  <div
                    key={report.id}
                    className='community__report--item'
                  >
                    <h3>Report {reportNumber}</h3>
                    <span>{report.title}</span>
                    <div
                      onClick={() => history.push(`/customer/account/community/report/${report.id}`)}
                    >
                      View Report{' >'}
                    </div>
                  </div>
                )
              })}
            </>
          )}
        </div>
      </Container>
    </PublicLayout>
  )
}
